/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlZeroDayAlertUploadJobStatus } from './ControlZeroDayAlertUploadJobStatus';
import {
    ControlZeroDayAlertUploadJobStatusFromJSON,
    ControlZeroDayAlertUploadJobStatusFromJSONTyped,
    ControlZeroDayAlertUploadJobStatusToJSON,
} from './ControlZeroDayAlertUploadJobStatus';

/**
 * 
 * @export
 * @interface ControlZeroDayAlertUploadJobSummary
 */
export interface ControlZeroDayAlertUploadJobSummary {
    /**
     * 
     * @type {string}
     * @memberof ControlZeroDayAlertUploadJobSummary
     */
    job_id: string;
    /**
     * 
     * @type {ControlZeroDayAlertUploadJobStatus}
     * @memberof ControlZeroDayAlertUploadJobSummary
     */
    status: ControlZeroDayAlertUploadJobStatus;
    /**
     * 
     * @type {string}
     * @memberof ControlZeroDayAlertUploadJobSummary
     */
    created_at: string;
    /**
     * 
     * @type {string}
     * @memberof ControlZeroDayAlertUploadJobSummary
     */
    started_at?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlZeroDayAlertUploadJobSummary
     */
    completed_at?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlZeroDayAlertUploadJobSummary
     */
    error_message?: string;
    /**
     * 
     * @type {number}
     * @memberof ControlZeroDayAlertUploadJobSummary
     */
    asset_count?: number;
}

/**
 * Check if a given object implements the ControlZeroDayAlertUploadJobSummary interface.
 */
export function instanceOfControlZeroDayAlertUploadJobSummary(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "job_id" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "created_at" in value;

    return isInstance;
}

export function ControlZeroDayAlertUploadJobSummaryFromJSON(json: any): ControlZeroDayAlertUploadJobSummary {
    return ControlZeroDayAlertUploadJobSummaryFromJSONTyped(json, false);
}

export function ControlZeroDayAlertUploadJobSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlZeroDayAlertUploadJobSummary {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'job_id': json['job_id'],
        'status': ControlZeroDayAlertUploadJobStatusFromJSON(json['status']),
        'created_at': json['created_at'],
        'started_at': !exists(json, 'started_at') ? undefined : json['started_at'],
        'completed_at': !exists(json, 'completed_at') ? undefined : json['completed_at'],
        'error_message': !exists(json, 'error_message') ? undefined : json['error_message'],
        'asset_count': !exists(json, 'asset_count') ? undefined : json['asset_count'],
    };
}

export function ControlZeroDayAlertUploadJobSummaryToJSON(value?: ControlZeroDayAlertUploadJobSummary | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'job_id': value.job_id,
        'status': ControlZeroDayAlertUploadJobStatusToJSON(value.status),
        'created_at': value.created_at,
        'started_at': value.started_at,
        'completed_at': value.completed_at,
        'error_message': value.error_message,
        'asset_count': value.asset_count,
    };
}

